var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"skuTable",attrs:{"auto-resize":"","highlight-hover-row":"","toolbar-config":_vm.tableToolbar,"data":_vm.tableData,"columns":_vm.tableColumns,"loading":_vm.loading,"height":_vm.tableHeight,"size":"small","row-id":"amzSkuCode","seq-config":{ startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize },"radio-config":!_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            strict: false,
            reserve: _vm.reserve,
          }
        : {},"checkbox-config":_vm.multiple
        ? {
            trigger: 'row',
            highlight: _vm.highlight,
            reserve: _vm.reserve,
          }
        : {}},on:{"radio-change":_vm.radioChange,"checkbox-change":_vm.checkboxChange,"checkbox-all":_vm.checkboxChange},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"defaultImageUrl",fn:function(ref){
        var row = ref.row;
return [_c('el-image',{staticStyle:{"width":"100px","height":"66px"},attrs:{"src":row.defaultImageUrl
            ? _vm.$osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg',"preview-src-list":[
          row.defaultImageUrl
            ? _vm.$osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg' ]}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('img',{staticStyle:{"width":"100px","height":"66px"},attrs:{"src":"/image/static/img/nopic.jpg"}})])])]}},{key:"displayName",fn:function(ref){
        var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.goodsName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.goodsNameEn))])]}},{key:"displayColor",fn:function(ref){
        var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.goodsColor))]),_c('br'),_c('span',[_vm._v(_vm._s(row.goodsColorEn))])]}},{key:"displayHscodeName",fn:function(ref){
        var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.hscodeName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.hscodeNameEn))])]}},{key:"needInspection",fn:function(ref){
        var row = ref.row;
return [(row.v_needInspection)?_c('el-tag',{attrs:{"size":"mini","type":row.needInspection === 'Y' ? 'success' : 'warning'}},[_vm._v(" "+_vm._s(row.v_needInspection)+" ")]):_vm._e()]}},{key:"status",fn:function(ref){
        var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.amzSkuStatus === 'Y'
            ? 'success'
            : row.amzSkuStatus === 'D'
            ? 'danger'
            : ''}},[_vm._v(" "+_vm._s(row.v_amzSkuStatus)+" ")])]}},{key:"createInfo",fn:function(ref){
            var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.createByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.createDate))])]}},{key:"modifyInfo",fn:function(ref){
            var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.modifyByName))]),_c('br'),_c('span',[_vm._v(_vm._s(row.modifyDate))])]}},{key:"empty",fn:function(ref){return [_c('div',{staticStyle:{"text-align":"center"}},[_c('img',{attrs:{"src":"/image/static/img/nodata.png"}}),_c('p',{staticClass:"no-data"},[_vm._v(" "+_vm._s(_vm.$l('INDEX.tips_no_data') || '暂无数据！')+" ")])])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }